import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedCloseIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.22922 6.22922C6.53485 5.92359 7.03037 5.92359 7.336 6.22922L17.7708 16.664C18.0764 16.9696 18.0764 17.4652 17.7708 17.7708C17.4652 18.0764 16.9696 18.0764 16.664 17.7708L6.22922 7.336C5.92359 7.03037 5.92359 6.53485 6.22922 6.22922Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.7708 6.22922C18.0764 6.53485 18.0764 7.03037 17.7708 7.336L7.336 17.7708C7.03037 18.0764 6.53485 18.0764 6.22922 17.7708C5.92359 17.4652 5.92359 16.9696 6.22922 16.664L16.664 6.22922C16.9696 5.92359 17.4652 5.92359 17.7708 6.22922Z",
			fill: "#333333"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedCloseIcon);
const Memo = memo(ForwardRef);
export default Memo;
